/**
 * Whether the Save action should prompt the user for a chart name before it
 * runs.
 *
 * Only a brand-new chart is prompted: a transient slug whose first save has not
 * yet promoted it into a real entry. A saved chart (never transient) and an
 * already-promoted transient chart both save silently — re-saves never
 * re-prompt.
 */
export const isUnsavedNewChart = (args: {
  transient: boolean
  chartID: string
  promotedChartID: string | null
}): boolean => args.transient && args.promotedChartID !== args.chartID
